import React from 'react';
import ArrowRightLight from '@/assets/arrowRightLight.svg';
import { MediaGalleryImageModel } from './MediaGalleryImagesList';

type MediaGalleryCarouselPaginatorModel = {
  activeImageIndex?: number | null;
  imageList: MediaGalleryImageModel[];
  carouselPrev: () => void;
  carouselNext: () => void;
} & React.HTMLAttributes<HTMLDivElement>;

const MediaGalleryCarouselPaginator = ({
  activeImageIndex,
  imageList,
  carouselPrev,
  carouselNext,
}: MediaGalleryCarouselPaginatorModel) => {
  return (
    <div className="pointer-events-auto flex">
      <button className="btn disabled:opacity-50" disabled={(activeImageIndex || 0) <= 0} onClick={carouselPrev}>
        <ArrowRightLight className="h-6 w-6 rotate-180 !fill-black" />
      </button>
      <div className="flex aspect-square h-[50px] items-center justify-center rounded-full border border-solid border-black p-1 text-xs whitespace-nowrap text-gray-600">
        {(activeImageIndex || 0) + 1} / {imageList.length}
      </div>
      <button
        className="btn disabled:opacity-50"
        disabled={(activeImageIndex || 0) >= imageList.length - 1}
        onClick={carouselNext}
      >
        <ArrowRightLight className="h-6 w-6 !fill-black" />
      </button>
    </div>
  );
};

export default MediaGalleryCarouselPaginator;
